export const dictionary = {
  pt_BR: {
    webDev: 'Desenvolvedor Web',
    mobDev: 'Desenvolvedor Mobile',
    frontDev: 'Desenvolvedor Frontend',
    intro: 'Introdução',
    history: 'Histórico',
    portfolio: 'Portfolio',
    about: 'Sobre',
    contact: 'Contato',
    skills: 'Habilidades',
    others: 'Outras',
    hideResume: 'Ocultar curriculo',
    showResume: 'Mostrar curriculo',
    visitWebsite: 'Ir para o website',
    description: 'Descrição',
    project: 'Projeto',
    tools: 'Ferramentas',
    techs: 'Tecnologias',
    sendMessage: 'Enviar mensagem',
    clear: 'Limpar',
    sending: 'Enviando...',
    emptyFields: 'Campo(s) vazio',
    tryAgain: 'Erro no envio, favor tentar novamente mais tarde',
    sentEmail: 'Email enviado com sucesso',
    email: 'Email',
    message: 'Mensagem',
    name: 'Nome',
    age: 'Idade',
    local: 'Local',
    goal: 'Objetivo',
    year: 'ano',
    personalInfo: 'Informações pessoais',
    consultant: 'Consultor Tecnológico',
    graduation: 'Graduação',
    assistant: 'Suporte Técnico',
    dev: 'Desenvolvedor',
    giveUpBtn: 'Desistir e ver histórico completo',
    areYouSureBtn: `Tem certeza que não quer tentar?`,
    playAgain: 'Jogar outra vez',
    mainErrorMsg: 'Parece que estamos tendo alguns problemas',
    subErrorMsg: 'a página que você solicitou não está disponivel',
    goHome: 'Ir para a home',
    share: 'Compartilhar',
    exp: 'Experiência',
  },
  en_US: {
    about: 'About',
    webDev: 'Web developer',
    mobDev: 'Mobile developer',
    frontDev: 'Frontend developer',
    intro: 'Intro',
    history: 'History',
    portfolio: 'Portfolio',
    contact: 'Contact',
    skills: 'Skills',
    others: 'Others',
    hideResume: 'Hide resume',
    showResume: 'Show resume',
    visitWebsite: 'Go to website',
    description: 'Description',
    project: 'Project',
    tools: 'Tools',
    techs: 'Technology',
    sendMessage: 'Send message',
    clear: 'Clear',
    sending: 'Sending...',
    emptyFields: 'Empty fields',
    tryAgain: 'Error sending, please try again later',
    sentEmail: 'Email sent',
    email: 'Email',
    message: 'Message',
    name: 'Name',
    age: 'Age',
    local: 'Local',
    goal: 'Objetivo',
    personalInfo: 'Personal Info',
    year: 'year',
    consultant: 'Tech consultant',
    graduation: 'Graduate',
    dev: 'Developer',
    assistant: 'Support',
    giveUpBtn: 'Give up and see the whole history',
    areYouSureBtn: `Are you sure you don't want to give it a shot?`,
    playAgain: 'Play Again',
    mainErrorMsg: `Look like we've had some troubles`,
    subErrorMsg: 'the page you are looking for not available!',
    goHome: 'Go to homepage',
    share: 'Share',
    exp: 'Experience',
  },
};
